import React from 'react';
import PropTypes from 'prop-types';

const DateConverter = ({ postedDate }) => {
  const formatPostedDateDifference = (postedDateString) => {
    const postedDate = new Date(postedDateString);
    const now = new Date();
    const differenceInSeconds = Math.floor((now - postedDate) / 1000);
    const differenceInHours = differenceInSeconds / 3600;

    const format = (value, unit) => {
      return `${value} ${unit}${value !== 1 ? 's' : ''} ago`;
    };

    if (differenceInSeconds < 60) {
      return format(differenceInSeconds, 'second');
    } else if (differenceInSeconds < 3600) {
      return format(Math.floor(differenceInSeconds / 60), 'minute');
    } else if (differenceInHours < 24) {
      return format(Math.floor(differenceInHours), 'hour');
    } else if (differenceInHours < 24 * 7) {
      return format(Math.floor(differenceInHours / 24), 'day');
    } else if (differenceInHours < 24 * 30) {
      return format(Math.floor(differenceInHours / (24 * 7)), 'week');
    } else if (differenceInHours < 24 * 365) {
      return format(Math.floor(differenceInHours / (24 * 30)), 'month');
    } else {
      return format(Math.floor(differenceInHours / (24 * 365)), 'year');
    }
  };

  return (
    <p>Posted {formatPostedDateDifference(postedDate)}</p>
  );
};

DateConverter.propTypes = {
  postedDate: PropTypes.string.isRequired,
};

export default DateConverter;
